import { createApp } from "vue"
import { createStore } from "vuex"
import {createRouter, createWebHistory} from "vue-router"

import App from "./App.vue"

import mitt from 'mitt';


//import jsontranslation from './assets/translations.json';
//jsontranslation

import pghome from "./components/pghome.vue"
import pgcosafacciamo from "./components/pgcosafacciamo.vue"
import pgcasestudies from "./components/pgcasestudies.vue"
import pgcaseitem from "./components/pgcaseitem.vue"
import pgesplorazioni from "./components/pgesplorazioni.vue"
import pgcontatti from "./components/pgcontatti.vue"
import pgprivacy from "./components/pgprivacy.vue"



import jsontranslations from "./assets/translations.json"
import jsoncompany from "./assets/company.json"

const mitter = mitt();

const store=createStore({

    state(){

        return {
            "currentfiltercategory":"",
            "currentfiltertag":"",
            "currentsearch":"",
            "categories":[],
            "tags":[],
            "cases":[]
            
        };

    },
    mutations:{

        fnSetCurrentFilterCategory(state,piValue)
        {
            state.currentfiltercategory=piValue;
        },


        fnSetCurrentFilterTag(state,piValue)
        {
            state.currentfiltertag=piValue;
        },

        fnSetCurrentSearch(state,piValue)
        {
            state.currentsearch=piValue;
        },


        fnSetCategories(state,piValue)
        {
            state.categories=piValue;
        },

        fnSetTags(state,piValue)
        {
            state.tags=piValue;
        },

        fnSetCases(state,piValue)
        {
            state.cases=piValue;
        },



    }



});

const router=createRouter({
    history: createWebHistory(),
    routes:[
        
        { path:"/:lang/home",component: pghome, props:true},
        { path:"/:lang/cosafacciamo",component: pgcosafacciamo, props:true},
        { path:"/:lang/casestudies",component: pgcasestudies, props:true},
        { path:"/:lang/caseitem",component: pgcaseitem, props:true},
        { path:"/:lang/esplorazioni",component: pgesplorazioni, props:true},
        { path:"/:lang/contatti",component: pgcontatti, props:true},
        { path:"/:lang/privacy",component: pgprivacy, props:true},
                         
        { path:"/",redirect: "/it/home"},

             
    ]

});


//variabile globale mi raccomando metterla prima di montare l'app
window.$translations=jsontranslations;
window.$company=jsoncompany;

window.$mitter=mitter;



const MountedApp = createApp(App).use(store).use(router).mount("#newlabapp");



window.$mountedapp=MountedApp;
